module.exports = __webpack_public_path__ + "img/1f950.fbe9256.svg";